import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/rt-logo.jpeg';
import { useCatalogStore } from '../../store/catalogStore';
import { useCollectionStore } from '../../store/collectionStore';
import { selectTotalItems, useCartStore } from '../../store/cartStore';
import { useAuthStore } from '../../store/authStore';
import { useWishlistStore } from '../../store/wishlistStore';
import SearchSection from '../SearchSection/SearchSection';
import './Header.css';

export default function Header() {
  const navigate = useNavigate();
  const clearCatalog = useCatalogStore((state) => state.clearCatalog);
  const fetchHome = useCollectionStore((state) => state.fetchHome);
  const totalItems = useCartStore(selectTotalItems);
  const authStatus = useAuthStore((state) => state.status);
  const wishCount = useWishlistStore((state) => state.ids.length);

  const handleLogoClick = () => {
    clearCatalog();
    void fetchHome();
  };

  const handleProfileClick = () => {
    navigate(authStatus === 'authed' ? '/profile' : '/login');
  };

  return (
    <div className="site-header">
      <header className="header page-container">
        <Link className="header__logo-link" to="/" onClick={handleLogoClick}>
          <img className="header__logo" src={logo} alt="Resham Tales logo" />
        </Link>
        <SearchSection />
        <div className="header__actions">
          <div className="header__profile">
            <button
              className="header__icon-btn"
              aria-label={authStatus === 'authed' ? 'Profile' : 'Sign in'}
              onClick={handleProfileClick}
            >
              <svg
                className="header__profile-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                width="28"
                height="28"
                aria-hidden="true"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              <span className="header__action-label">Profile</span>
            </button>
            {authStatus === 'guest' && (
              <div className="header__profile-popover">
                <strong>Welcome</strong>
                <p>To access account and manage orders</p>
                <Link to="/login">Login/ signup</Link>
              </div>
            )}
          </div>
          <button
            className="header__icon-btn"
            aria-label={wishCount ? `Wishlist, ${wishCount} items` : 'Wishlist'}
            onClick={() => navigate('/wishlist')}
          >
            <svg
              className="header__wish-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              width="28"
              height="28"
              aria-hidden="true"
            >
              <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8z" />
            </svg>
            <span className="header__action-label">Wishlist</span>
            {wishCount > 0 && <span className="header__badge">{wishCount}</span>}
          </button>
          <button className="header__icon-btn" aria-label="Cart" onClick={() => navigate('/checkout')}>
            <svg
              className="header__cart-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              width="28"
              height="28"
              aria-hidden="true"
            >
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 0 1-8 0" />
            </svg>
            <span className="header__action-label">Bag</span>
            {totalItems > 0 && <span className="header__badge">{totalItems}</span>}
          </button>
        </div>
      </header>
    </div>
  );
}
